import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { connect } from 'react-redux';
import { updateCurrentQueryDetiails } from '../../../actions/query';
import { Dispatch, QueryRequest, store } from '../../../utils/types';
import { usePrevious } from '../../../utils/usePrevious';

const { Option } = Select;

const CohortDiseaseName = ({ values, setValues, categoryStructure }: any) => {
  const [cohortDiseaseNames, setCohortDiseaseNames] = useState<string[]>([]);

  const previousNetworkName = usePrevious(values.networkName);

  useEffect(() => {
    if (!categoryStructure || !values.networkType || !values.networkName) {
      return;
    }

    // network name is same no need to change something
    if (previousNetworkName === values.networkName) {
      return;
    }

    const cn = categoryStructure[values.networkType][values.networkName];
    setCohortDiseaseNames(Object.keys(cn));
  }, [categoryStructure, values, setValues, previousNetworkName]);

  const onChange = (value: string) => {
    if (!categoryStructure || !values.networkType || !values.networkName) {
      return;
    }
    const c = categoryStructure[values.networkType][values.networkName][value];

    setValues({
      ...values,
      cohortDiseaseName: value,
      categoryId: c?.id,
      locations: c?.locations,
      search: [],
    });
  };

  return (
    <div id="cohort-disease-select" className="mt-5">
      <Form.Item labelCol={{ span: 24 }} label="Cohort/Disease">
        <Select
          value={values.cohortDiseaseName}
          onChange={onChange}
          placeholder="Select"
          className="w-full rounded-select"
          disabled={!values.networkName}
        >
          {cohortDiseaseNames.map((o: string, i: any) => (
            <Option key={i} value={o}>
              {o}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};

const mapStateToProps = (state: store) => ({
  values: state.query.currentQueryDetails,
  categoryStructure: state.dataTypes.catStructure,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setValues: (currentQueryDetails: QueryRequest) =>
    dispatch(updateCurrentQueryDetiails(currentQueryDetails)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CohortDiseaseName);
